import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UiTranslateModule } from '@fcom/ui-translate';
import { UiComponentsModule } from '@fcom/ui-components';
import { ComponentsModule, PipesModule } from '@fcom/common';
import { CmsModule } from '@fcom/cms';

import { DapiIncludedProductsComponent } from './included-products/included-products.component';
import { DapiIncludedServiceComponent } from './included-service/included-service.component';
import { DapiIncludedProductItemComponent } from './included-product-item/included-product-item.component';
import { DapiIncludedProductHeadingComponent } from './included-product-heading/included-product-heading.component';
import { DapiIncludedTicketsComponent } from './included-tickets/included-tickets.component';
import { ModifyButtonComponent } from './modify-button/modify-button.component';
import { IncludedBoundFlightsHeadingComponent } from './included-bound-flights-heading/included-bound-flights-heading.component';
import { UpsellCardComponent } from './upsell-card/upsell-card.component';
import { GroupedServicesComponent } from './grouped-services/grouped-services.component';
import { InformationModalComponent } from './information-modal/information-modal.component';

const COMPONENTS = [
  DapiIncludedProductHeadingComponent,
  DapiIncludedProductsComponent,
  DapiIncludedProductItemComponent,
  DapiIncludedServiceComponent,
  DapiIncludedTicketsComponent,
  ModifyButtonComponent,
  IncludedBoundFlightsHeadingComponent,
  UpsellCardComponent,
  GroupedServicesComponent,
  InformationModalComponent,
];

@NgModule({
  imports: [CommonModule, PipesModule, UiTranslateModule, UiComponentsModule, ComponentsModule, CmsModule],
  exports: [...COMPONENTS],
  declarations: [...COMPONENTS],
  providers: [],
})
export class DapiComponentsModule {
  constructor(@Optional() @SkipSelf() parentModule: DapiComponentsModule) {
    if (parentModule) {
      throw new Error('DapiComponentsModule is already loaded. Import in your base AppModule only.');
    }
  }
}
